import { maybeSlugToUuid } from '#pplx/frontend/apps/ask/permalink-slug/permalinkSlug.js';
export const CREDIT_UPSELL_RETURN_PARAM = 'credit_upsell_return';
/** Capture only a recognized thread destination, dropping all user-authored URL data. */
export function getCreditUpsellReturnPath(path) {
    const pathname = path.split(/[?#]/, 1)[0] ?? '';
    const match = /^(\/computer\/(?:t|tasks)|\/session|\/search(?:\/new)?)\/([^/]+)\/?$/.exec(pathname);
    if (!match?.[1] || !match[2])
        return undefined;
    const uuid = maybeSlugToUuid(match[2]);
    if (!uuid)
        return undefined;
    return `${match[1]}/${uuid}`;
}
export function creditUpsellCheckoutReturnPath(path) {
    return `${path}?${CREDIT_UPSELL_RETURN_PARAM}=1`;
}
//# sourceMappingURL=creditUpsellReturn.js.map